'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toast = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _functional = require('../../utils/functional');

var _tracking = require('../../utils/tracking');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var MODULE_NAME = 'js-Toast';

var classes = {
  VISIBLE: 'tst-Notification-visible'
};

var tracking = {
  CATEGORY: 'Toast Notification',
  ACTION_OPEN: 'Open Notification',
  ACTION_CLOSE: 'Close Notification',
  ACTION_VIEW: 'View Notification Link'
};

var defaultConfig = {
  delay: 5000,
  trackingCategory: tracking.CATEGORY
};

var Toast = exports.Toast = function () {
  function Toast(el) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck3.default)(this, Toast);

    this.el = el;
    this.config = (0, _assign2.default)({}, defaultConfig, this.getConfig(), config);
    this.els = this.getEls();

    this.setupListeners();
  }

  (0, _createClass3.default)(Toast, [{
    key: 'setupListeners',
    value: function setupListeners() {
      var _this2 = this;

      var _this = this;
      this.els.closeButton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        _this.setVisibility(false);

        (0, _tracking.trackGtag)({
          eventCategory: _this2.config.trackingCategory,
          eventAction: tracking.ACTION_CLOSE,
          eventLabel: _this2.config.trackingEventLabel
        });
      });

      if (this.el.tagName === 'A') {
        this.el.addEventListener('click', function (e) {
          (0, _tracking.trackGtag)({
            eventCategory: _this2.config.trackingCategory,
            eventAction: tracking.ACTION_VIEW,
            eventLabel: _this2.config.trackingEventLabel
          });
        });
      }
    }
  }, {
    key: 'setVisibility',
    value: function setVisibility(val) {
      var _this3 = this;

      this.el.classList.toggle(classes.VISIBLE, val);

      if (val) {
        (0, _tracking.trackGtag)({
          eventCategory: this.config.trackingCategory,
          eventAction: tracking.ACTION_OPEN,
          eventLabel: this.config.trackingEventLabel
        });

        setTimeout(function () {
          _this3.setVisibility(false);
        }, this.config.delay);
      }
    }
  }, {
    key: 'getConfig',
    value: function getConfig() {
      var _el$dataset = this.el.dataset,
          delay = _el$dataset.delay,
          trackingCategory = _el$dataset.trackingCategory,
          trackingEventLabel = _el$dataset.trackingEventLabel;

      return (0, _assign2.default)({}, delay, trackingCategory, trackingEventLabel);
    }
  }, {
    key: 'getEls',
    value: function getEls() {
      var context = this.el;

      return {
        closeButton: (0, _functional.getElement)('.' + MODULE_NAME + '_CloseButton', { context: context })
      };
    }
  }]);
  return Toast;
}();